import { Store, Id } from '../store/storeTypes';

export function isInvitationPending(state: Store, id: Id) {
  return state.api.pendingInvitationUserIds.indexOf(id) >= 0;
}
